import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetCodeListResponse = {
  CodeDiv: string;
  CodeValue: string;
  CodeName: string;
  CodeDivName: string;
  Reserve1: string;
  Reserve2: string;
  ReserveNum1: number;
  ReserveNum2: number;
  SortNum: number;
  StartOrderCode: string;
  EndOrderCode: string;
}[];

/**
 * コードマスタ取得サービス
 * @export GetCodeListService
 * @class GetCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCodeListService extends PlessJsonResponderSub<GetCodeListResponse> {
  private codeDiv: string = null;
  private reserveNum: string = null;
  private storeObj: object; // 格納先オブジェクト
  private storeParam: string; // 格納先属性名
  private codeValue : string = null;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CodeDiv: this.codeDiv,
        ReserveNum1: this.reserveNum,
        CodeValue: this.codeValue,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param codeDiv コード区分
   * @param reserveNum 予備
   * @param obj 格納先オブジェクト
   * @param param 格納先属性名
   * @param f コールバック
   * @memberof GetCodeListService
   */
  execute(
    codeDiv: string,
    reserveNum: string,
    obj: object,
    param: string,
    s: () => void = null,
    f: () => void = null,
    codeValue?: string
  ): void {
    this.codeDiv = codeDiv;
    this.reserveNum = reserveNum;
    this.storeObj = obj;
    this.storeParam = param;
    if (codeValue !== null) {
      this.codeValue = codeValue;
    }
    this.succeed = s;
    this.fail = f;
    this.send('KYMW02getCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: GetCodeListResponse) {
    if (this.storeObj && this.storeParam && this.storeParam in this.storeObj)
      this.storeObj[this.storeParam] = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param codeDiv
   * @param reserveNum
   * @returns Promise<GetCodeListResponse>
   */
  public executeAsync(
    codeDiv: string,
    reserveNum: string,
    obj: object,
    param: string,
    codeValue?: string,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        codeDiv,
        reserveNum,
        obj,
        param,
        () => resolve(),
        () => reject(),
        codeValue,
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
